import { some, every } from 'lodash';

export function someHasError(responses) {
	return some(responses, 'error');
}

export function everyIsComplete(responses) {
	return every(responses, 'data.data.success');
}
